import { render } from "./TableSearch.vue?vue&type=template&id=65b1bec4&scoped=true"
import script from "./TableSearch.vue?vue&type=script&lang=js"
export * from "./TableSearch.vue?vue&type=script&lang=js"

import "./TableSearch.vue?vue&type=style&index=0&id=65b1bec4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b1bec4"]])

export default __exports__